<template>
  <div class="container">
    <!-- Dokter Pending (Horizontal Card Scroll) -->
    <div class="card-scroll-wrapper" v-if="pendingDoctors.length">
      <div class="card-list">
        <div
          class="doctor-card"
          v-for="doctor in pendingDoctors"
          :key="doctor.id"
          @click="openDetailModal(doctor)"
        >
          <h4>{{ doctor.name }}</h4>
          <p style="color: #888">{{ doctor.code }}</p>
          <a-tag color="blue">Doctor Spesialis Baru - {{ userData.user.programType }}</a-tag>
        </div>
      </div>
    </div>

    <!-- Search & Filter -->
    <a-input-search
      v-model:value="search"
      placeholder="Cari nama dokter"
      enter-button
      style="margin: 16px 0"
    />

    <a-radio-group v-model:value="statusFilter" style="margin-bottom: 16px">
      <a-radio-button value="all">Semua</a-radio-button>
      <a-radio-button value="true">Disetujui</a-radio-button>
      <a-radio-button value="false">Ditolak</a-radio-button>
    </a-radio-group>

    <!-- Table -->
    <a-table
      class="responsive-table"
      :columns="columns"
      :data-source="filteredDoctors"
      :pagination="{ pageSize: 10 }"
      :scroll="{ x: 620 }"
      row-key="id"
      @row-click="openDetailModal"
    >
      <template #status="{ text }">
        <span :style="{ color: text ? '#52c41a' : '#f5222d' }">{{
          text ? 'Disetujui' : 'Ditolak'
        }}</span>
      </template>
    </a-table>

    <a-modal
      v-model:visible="visible"
      :title="'DETAIL DOKTER'"
      :footer="null"
      @cancel="visible = false"
    >
      <div class="doctor-detail-card">
        <h3>{{ selectedDoctor?.fullname }}</h3>
        <p style="color: #999; margin-top: -8px">{{ selectedDoctor?.hospital }}</p>
      </div>

      <div class="row doctor-detail-grid">
        <div class="col-6 mb-2"><strong>Tanggal Pengajuan</strong><br /></div>
        <div class="col-6 mb-2">: {{ formatDateToDDMMYYYY(selectedDoctor?.createdAt) }}</div>
        <div class="col-6 mb-2"><strong>No. KTP</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedDoctor?.idNumber }}</div>
        <!-- <div class="col-6 mb-2"><strong>Dokumen Persetujuan</strong><br /></div>
        <div class="col-6 mb-2">
          : <a>{{ selectedDoctor?.consent }}</a>
        </div> -->
        <div class="col-6 mb-2"><strong>Lokasi</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedDoctor?.city }}</div>
      </div>

      <div v-if="selectedDoctor?.status === 'Pending'" class="doctor-detail-actions">
        <a-button
          type="primary"
          style="background: linear-gradient(to right, #f2994a, #f2c94c); border: none"
        >
          DISETUJUI
        </a-button>
        <a-button danger>
          TIDAK DISETUJUI
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { getListDoctor } from '../../services/axios/pulih'
export default {
  setup() {
    const search = ref('')
    const statusFilter = ref('all')
    const visible = ref(false)
    const selectedDoctor = ref(null)
    const userData = ref({})
    const pendingDoctors = ref([])
    const doctors = ref([])

    const columns = [
      { title: 'Nama', dataIndex: 'fullname', key: 'name' },
      { title: 'Kode Verifikasi', dataIndex: 'verificationCode', key: 'code' },
      {
        title: 'Status',
        dataIndex: 'isApproved',
        key: 'status',
        slots: { customRender: 'status' },
      },
    ]

    const filteredDoctors = computed(() =>
      doctors.value.filter(d => {
        const matchName = d.fullname.toLowerCase().includes(search.value.toLowerCase())
        const matchStatus =
          statusFilter.value === 'all' || String(d.isApproved) === statusFilter.value
        return matchName && matchStatus
      }),
    )

    const fetchData = async type => {
      const data = await getListDoctor(type)
      pendingDoctors.value = data.filter(e => e.isApproved === null)
      doctors.value = data.filter(e => e.isApproved !== null)
    }
    const formatDateToDDMMYYYY = isoString => {
      const date = new Date(isoString)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0') // bulan dimulai dari 0
      const year = date.getFullYear()
      return `${day}-${month}-${year}`
    }

    onMounted(() => {
      userData.value = JSON.parse(localStorage.getItem('userData'))
      fetchData(userData.value.user.programType)
    })

    const openDetailModal = doctor => {
      selectedDoctor.value = doctor
      visible.value = true
    }

    return {
      search,
      statusFilter,
      visible,
      selectedDoctor,
      doctors,
      columns,
      pendingDoctors,
      filteredDoctors,
      formatDateToDDMMYYYY,
      openDetailModal,
    }
  },
}
</script>

<style scoped>
.container {
  margin: 0 auto;
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.card-scroll-wrapper {
  overflow-x: auto;
  margin-bottom: 16px;
}
.card-list {
  display: flex;
  gap: 16px;
  min-width: max-content;
}
.doctor-card {
  border: 2px solid #9b1c7b;
  border-radius: 12px;
  padding: 12px 16px;
  min-width: 240px;
  text-align: center;
  background: #fdfcff;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.doctor-detail-card {
  text-align: center;
  margin-bottom: 16px;
}
.doctor-detail-grid {
  margin-bottom: 16px;
}
.doctor-detail-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
}

.responsive-table {
  width: 100%;
}

:global(.responsive-table .ant-table-content) {
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
}

:global(.responsive-table .ant-table-thead > tr > th),
:global(.responsive-table .ant-table-tbody > tr > td) {
  white-space: nowrap;
}

:global(.responsive-table .ant-pagination) {
  flex-wrap: wrap;
  row-gap: 8px;
}

@media (max-width: 576px) {
  .container {
    padding: 16px 12px;
    border-radius: 0;
    box-shadow: none;
  }

  .doctor-card {
    min-width: 200px;
    padding: 12px;
  }

  :global(.responsive-table .ant-table-thead > tr > th),
  :global(.responsive-table .ant-table-tbody > tr > td) {
    padding: 10px 12px;
    font-size: 12px;
  }

  :global(.responsive-table .ant-pagination) {
    justify-content: center;
  }
}
</style>
